module.exports = __webpack_public_path__ + "static/case_details_03-5c06ceaacaa114cc62a053778cbdc839.jpg";